
import React from 'react';

export const DecisionLevelBadge = ({ level }) => {
  const normalizedLevel = level ? String(level).toLowerCase() : "";
  let bgColor, textColor, borderColor;

  if (normalizedLevel === "auto_action") {
    bgColor = "rgba(34, 197, 94, 0.1)"; 
    textColor = "#4ade80"; 
    borderColor = "rgba(34, 197, 94, 0.25)";
  } else if (normalizedLevel === "recommendation") {
    bgColor = "rgba(56, 189, 248, 0.1)"; 
    textColor = "#7dd3fc"; 
    borderColor = "rgba(56, 189, 248, 0.25)";
  } else if (normalizedLevel === "escalation" || normalizedLevel === "alarm") {
    bgColor = "rgba(244, 63, 94, 0.1)"; 
    textColor = "#fb7185"; 
    borderColor = "rgba(244, 63, 94, 0.25)";
  } else {
    bgColor = "rgba(148, 163, 184, 0.1)"; 
    textColor = "#cbd5e1"; 
    borderColor = "rgba(148, 163, 184, 0.25)";
  }

  const displayText = level ? String(level).replace(/_/g, " ") : "-";

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4px 12px",
        borderRadius: "999px",
        backgroundColor: bgColor,
        color: textColor,
        border: `1px solid ${borderColor}`,
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: 1.2,
        textTransform: "capitalize",
        whiteSpace: "nowrap",
        width: "max-content",
      }}
    >
      {displayText}
    </div>
  );
};